/* MadMouse — Cursor stamp trail
   On each mousemove farther than SPAWN_GAP px from the last stamp, take the
   next element from a 10-shape pool (cyclic), place it at the cursor with a
   freshly randomised brand colour, fade & shrink it out. Cursor idle → no new
   stamps → existing fade away. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  var COLORS    = ['#5A3FD9', '#FFE73C']; /* brand violet + accent yellow */
  var SPAWN_GAP = 80;                     /* min px between consecutive stamps */

  function init() {
    if (typeof gsap === 'undefined') return false;

    var nodes = document.querySelectorAll('[data-mm-trail]');
    if (!nodes.length) return true;

    /* Prep: centred on their own (x,y), invisible until first spawn. */
    Array.prototype.forEach.call(nodes, function (el) {
      gsap.set(el, { xPercent: -50, yPercent: -50, opacity: 0, scale: 1 });
    });

    var lastX = -9999;
    var lastY = -9999;
    var idx   = 0;

    window.addEventListener('mousemove', function (e) {
      var dx = e.clientX - lastX;
      var dy = e.clientY - lastY;
      if (dx * dx + dy * dy < SPAWN_GAP * SPAWN_GAP) return;
      lastX = e.clientX;
      lastY = e.clientY;

      var el = nodes[idx];
      idx = (idx + 1) % nodes.length;

      /* Fresh random colour on every spawn */
      el.style.color = COLORS[Math.floor(Math.random() * COLORS.length)];

      /* Reset any in-flight tween, stamp, then fade & shrink out */
      gsap.killTweensOf(el);
      gsap.set(el, {
        x: e.clientX,
        y: e.clientY,
        opacity: 1,
        scale: 1.05,
        rotation: (Math.random() - 0.5) * 40
      });
      gsap.to(el, {
        opacity: 0,
        scale: 0.5,
        duration: 0.9,
        ease: 'power2.out'
      });
    }, { passive: true });

    return true;
  }

  /* GSAP loads with defer via CDN — poll briefly until it's ready. */
  if (!init()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (init() || ++tries > 80) clearInterval(poll); /* ~4s cap */
    }, 50);
  }
})();
